import * as React from "react";
import { Subheading, BodyText } from "./Text";
import { Space } from "./Space";
import UnstyledButton from "../../components/buttons/UnstyledButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { Fragment as _Fragment } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var ListItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var leftAccessory = _ref.leftAccessory,
    rightAccessory = _ref.rightAccessory,
    title = _ref.title,
    description = _ref.description,
    cursor = _ref.cursor,
    onClick = _ref.onClick,
    width = _ref.width;
  var ButtonOrSpan = onClick ? UnstyledButton : "span";
  return _jsxs(ButtonOrSpan, {
    ref: ref,
    onClick: onClick,
    sx: {
      display: "flex",
      alignItems: "center",
      position: "relative",
      width: width,
      cursor: cursor
    },
    children: [leftAccessory && _jsx(ListItemLeftAccessory, {
      children: leftAccessory
    }), (title || description) && _jsx(TextSection, {
      title: title,
      description: description
    }), rightAccessory && _jsx(ListItemRightAccessory, {
      children: rightAccessory
    })]
  });
});
export var ListItemTitle = function ListItemTitle(_ref2) {
  var children = _ref2.children,
    nowrap = _ref2.nowrap;
  if (typeof children === "string") {
    return _jsx(Subheading, {
      nowrap: nowrap || undefined,
      children: children
    });
  } else {
    return children || null;
  }
};
ListItemTitle.displayName = "ListItemTitle";
export var ListItemDescription = function ListItemDescription(_ref3) {
  var children = _ref3.children;
  if (typeof children === "string") {
    return _jsx(BodyText, {
      nowrap: true,
      children: children
    });
  } else {
    return children || null;
  }
};
ListItemDescription.displayName = "ListItemDescription";
var TextSection = function TextSection(_ref4) {
  var title = _ref4.title,
    description = _ref4.description;
  if (title && !description) {
    return _jsx("div", {
      sx: {
        position: "relative"
      },
      children: _jsx(ListItemTitle, {
        children: title
      })
    });
  }
  return _jsxs("div", {
    sx: {
      minWidth: "0",
      position: "relative"
    },
    children: [_jsx(ListItemTitle, {
      children: title
    }), _jsx(ListItemDescription, {
      children: description
    })]
  });
};
var ListItemLeftAccessory = function ListItemLeftAccessory(_ref5) {
  var children = _ref5.children;
  return _jsxs(_Fragment, {
    children: [_jsx("div", {
      sx: {
        display: "flex",
        alignItems: "center",
        position: "relative"
      },
      children: children
    }), _jsx(Space, {
      kind: "inline",
      size: "xs"
    })]
  });
};
ListItemLeftAccessory.displayName = "ListItemLeftAccessory";
var ListItemRightAccessory = function ListItemRightAccessory(_ref6) {
  var children = _ref6.children;
  return _jsxs(_Fragment, {
    children: [_jsx("div", {
      sx: {
        display: "flex",
        flexGrow: 1,
        position: "relative"
      }
    }), _jsx(Space, {
      kind: "inline",
      size: "s"
    }), children]
  });
};
ListItemRightAccessory.displayName = "ListItemRightAccessory";